import { H1, Stack, screen, useBreakpoints } from '@tumelo/designsystem'
import React from 'react'
import { styled } from 'styled-components'
import { OuterContainerLayout } from '@/components/PageWrapper/OuterContainerLayout'
import { largeUpStyle } from '@/styles/outerContainerStyles'
import { HeaderLogo } from './HeaderLogo'
import { HeaderMenuButton } from './HeaderMenuButton'
import { HeaderNavigation } from './HeaderNavigation'
import { HeaderProfileIcon } from './HeaderProfileIcon'

interface Props {
  pageH1: string
}

export const ProfileHeader: React.FC<Props> = ({ pageH1 }) => {
  const { isXsmallOnly, isSmallUp, isMediumUp, isLargeUp } = useBreakpoints()
  return (
    <StyledHeader>
      <StyledOuterContainerLayout $withMaxWidth={false}>
        <StyledStack>
          {(isXsmallOnly || isSmallUp) && <HeaderMenuButton />}
          {(isMediumUp || isLargeUp) && (
            <Stack flexDirection="row" justifyContent="space-between" alignItems="center" gap="4.0rem">
              <Stack flexDirection="row" justifyContent="flex-start" alignItems="center" gap="4.0rem">
                <HeaderLogo />
                <HeaderNavigation />
              </Stack>
              <HeaderProfileIcon />
            </Stack>
          )}
        </StyledStack>
        <StyledH1 mb="0" color="white">
          {pageH1}
        </StyledH1>
      </StyledOuterContainerLayout>
    </StyledHeader>
  )
}

const StyledHeader = styled.header`
  background-color: ${({ theme }) => theme.colors.background.dark};
`

const StyledOuterContainerLayout = styled(OuterContainerLayout)`
  padding-bottom: 7.2rem;

  @media ${screen.mediumUp} {
    padding-bottom: 8rem;
  }

  @media ${screen.largeUp} {
    padding-bottom: 9.6rem;
  }
`

const StyledStack = styled(Stack)`
  margin-bottom: 3.2rem;

  @media ${screen.mediumUp} {
    margin-bottom: 4rem;
  }

  @media ${screen.largeUp} {
    margin-bottom: 4.8rem;
  }
`

const StyledH1 = styled(H1)`
  ${largeUpStyle({ $withMaxWidth: true })}
  @media ${screen.largeUp} {
    padding-bottom: 0;
  }
`
